import React, { ReactElement, ReactNode } from 'react';
import { LinkWithTooltip } from './LinkWithTooltip';
import { FaQuestionCircle } from 'react-icons/fa';

type TooltipProps = { id: string; href?: string; tooltip: ReactNode };

export function Tooltip(props: TooltipProps): ReactElement {
    const { id, href, tooltip } = props;
    return (
        <LinkWithTooltip tooltip={tooltip} href={href ? href : '#'} id={id}>
            <FaQuestionCircle />
        </LinkWithTooltip>
    );
}
